import { render, staticRenderFns } from "./CajaMensualShow.vue?vue&type=template&id=ca3312bc"
import script from "./CajaMensualShow.vue?vue&type=script&lang=js"
export * from "./CajaMensualShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports